// Owner Chat Widget v1.0
import { render } from 'preact'
import { App } from './App'

function mount() {
	const container = document.createElement('div')
	container.id = 'owner-chat-root'
	document.body.appendChild(container)

	// Inject base styles
	const style = document.createElement('style')
	style.textContent = `
		#owner-chat-root {
			position: fixed;
			bottom: 0;
			right: 0;
			z-index: 99999;
			font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
		}
		#owner-chat-root * {
			box-sizing: border-box;
			margin: 0;
			padding: 0;
		}
	`
	document.head.appendChild(style)

	render(<App />, container)
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', mount)
} else {
	mount()
}
